import { render, staticRenderFns } from "./PhoneDialer.vue?vue&type=template&id=1a1399e3&scoped=true&"
import script from "./PhoneDialer.vue?vue&type=script&lang=js&"
export * from "./PhoneDialer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1399e3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1399e3')) {
      api.createRecord('1a1399e3', component.options)
    } else {
      api.reload('1a1399e3', component.options)
    }
    module.hot.accept("./PhoneDialer.vue?vue&type=template&id=1a1399e3&scoped=true&", function () {
      api.rerender('1a1399e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/phone/components/PhoneDialer.vue"
export default component.exports